import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable()
export class UrlManagerService {

    constructor(
        private router: Router
    ) {

    }

    /**
     * Получить «Чистый» Url без QueryParams
     * @param url (/equipment/index?calibration_status=2)
     * @return string (/equipment/index)
     */
    static getUrlWithoutQuery(url: string): string {
        const dividerIndex = url.indexOf('?');

        if (dividerIndex < 0) {
            return url;
        } else {
            return url.substring(0, dividerIndex);
        }
    }

    /**
     * Получить Query параметры. По хорошему бы воспользоваться Router.urlParse и оттуда достать параметры,
     * но нам нужно использовать метод именно как static, поэтому придется добыавть параметры вручную
     * @param url
     */
    static getQueryParams(url: string): object {
        const dividerIndex = url.indexOf('?');

        if (dividerIndex < 0) {
            return null;
        }

        const paramsString = url.substr(dividerIndex + 1);

        if (!paramsString) {
            return null;
        }

        const params = {};

        paramsString.split('&').forEach(part => {
            const [key, value] = part.split('=');
            params[key] = value;
        });

        return params;
    }

    /**
     * Программный редирект на указанный URL с учетом QueryParams
     * @param url
     */
    navigateTo(url: string) {
        const path = UrlManagerService.getUrlWithoutQuery(url);
        const query = UrlManagerService.getQueryParams(url);

        if (!path) {
            return;
        }

        this.router.navigate([path], {queryParams: query});
    }
}
